import { CALL_API } from '@aftonbladet/redux-api-middleware';

import { RECIRCULATION_REQUEST, RECIRCULATION_SUCCESS, RECIRCULATION_FAILURE } from './types';

/* eslint-disable import/prefer-default-export */
export const fetchRecirculationListAction = ({ endpoint, force = false }) => ({
    [CALL_API]: {
        endpoint,
        method: 'GET',
        types: [RECIRCULATION_REQUEST, RECIRCULATION_SUCCESS, RECIRCULATION_FAILURE],
        bailout: (state) => !force && !!state.recirculation.items.length,
    },
});
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/recirculation.js
 **/